import React from "react";
import ReactECharts from "echarts-for-react";
 
const PiewithScrollableLegend = ({ legendData, seriesData, headingName, height, center }) => {
  const option = {
    tooltip: {
      trigger: "item",
      formatter: "{a} <br/>{b} : {c} ({d}%)",
    },
    legend: {
      type: "scroll",
      orient: "vertical",
      right: 10,
      top: 20,
      bottom: 20,
      data: legendData,
    },
    series: [
      {
        name: headingName,
        type: "pie",
        radius: "55%",
        center: center ? center : ["40%", "50%"],
        data: seriesData,
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
        label: {
          show: false, 
        },
        labelLine: {
          show: false, 
        },
      },
    ],
  };
 
  return (
    <div style={{ width: "100%", height: height ? height : "500px" }}>
      <ReactECharts
        option={option}
        style={{ height: "100%", width: "100%" }}
      />
    </div>
  );
};
 
export default PiewithScrollableLegend;